import http from '../shared/HttpCommon';
import { CanceledError } from 'axios';
import { AlertManagement } from '../shared/interfaces/IAlerts';
import { Dispatch, SetStateAction } from 'react';

const getAlertSettings = async (signal: AbortSignal) => {
  try {
    const { data } = await http.get('/alerts', { signal });

    data.alerts.sort((a: AlertManagement, b: AlertManagement) => {
      if (a.type === 'NEW_CRAWL') {
        return -1;
      } else if (b.type === 'NEW_CRAWL') {
        return 1;
      } else {
        return 0;
      }
    });
    return data;
  } catch (error) {
    if (error instanceof CanceledError) {
    } else {
      console.error(error);
    }
  }
};

const saveAlertSettings = async (
  alertManagementNew: AlertManagement,
  alertManagementUpdated: AlertManagement,
  loading: Dispatch<SetStateAction<boolean>>
) => {
  try {
    loading(true);
    await http.patch('/alerts', { alerts: [alertManagementNew, alertManagementUpdated] });
    loading(false);
  } catch (error) {
    loading(false);
    console.error(error);
  }
};

const AlertService = {
  getAlertSettings,
  saveAlertSettings,
};

export default AlertService;
